import React, { useState } from 'react'
import baseWooferImg from './assets/woofers/base.png'
import { attributes, WooferAttributeKey } from './woofers'
import {
    MainContainer,
    PlaygroundContainer,
    SubContainer,
    PageSwitcher,
    PageLink,
    WooferContainer,
    ControlsContainer,
    SelectContainer,
    AttributeLabel,
    RarityContainer,
    RarityAttributeContainer,
    RarityAttributeLabel,
    RarityTraitLabelAndImage,
    RarityImageContainer,
    RarityTraitsContainer,
} from './components'

export const Playground = () => {
    const [activePage, setActivePage] = useState<'playground' | 'rarity'>(
        'playground'
    )

    const [woofer, setWoofer] = useState<{
        background: (typeof attributes)['background']['items'][0]
        head: (typeof attributes)['head']['items'][0]
        mouth: (typeof attributes)['mouth']['items'][0]
        clothing: (typeof attributes)['clothing']['items'][0]
        eyes: (typeof attributes)['eyes']['items'][0]
        skin: (typeof attributes)['skin']['items'][0]
    }>({
        background: attributes.background.items[3],
        head: attributes.head.items[18],
        skin: attributes.skin.items[9],
        eyes: attributes.eyes.items[0],
        clothing: attributes.clothing.items[0],
        mouth: attributes.mouth.items[3],
    })

    return (
        <MainContainer>
            <SubContainer>
                <PageSwitcher>
                    <PageLink
                        active={activePage === 'playground'}
                        onClick={() => setActivePage('playground')}
                    >
                        Playground
                    </PageLink>
                    -
                    <PageLink
                        active={activePage === 'rarity'}
                        onClick={() => setActivePage('rarity')}
                    >
                        Rarity table
                    </PageLink>
                </PageSwitcher>
                {activePage === 'playground' && (
                    <PlaygroundContainer>
                        <WooferContainer>
                            {Object.keys(woofer).map((attrField) => {
                                const field = attrField as WooferAttributeKey

                                return woofer[field].image ? (
                                    <img
                                        id={field}
                                        key={field}
                                        src={woofer[field].image}
                                        alt={woofer[field].text}
                                    />
                                ) : null
                            })}
                        </WooferContainer>
                        <ControlsContainer>
                            {Object.keys(attributes).map((attrField) => {
                                const field = attrField as WooferAttributeKey
                                const attr = attributes[field]

                                return (
                                    <SelectContainer key={field}>
                                        <AttributeLabel>
                                            {attr.label}
                                        </AttributeLabel>
                                        <select
                                            onChange={(e) => {
                                                setWoofer({
                                                    ...woofer,
                                                    [attrField]:
                                                        attr.items.find(
                                                            ({ key }) =>
                                                                key ===
                                                                e.target.value
                                                        ),
                                                })
                                            }}
                                            defaultValue={woofer[field].key}
                                        >
                                            {attr.items.map((item) => (
                                                <option
                                                    key={item.key}
                                                    value={item.key}
                                                >
                                                    {item.text}
                                                </option>
                                            ))}
                                        </select>
                                        <AttributeLabel
                                            style={{
                                                color: woofer[field].color,
                                            }}
                                        >
                                            {woofer[field].fact} (
                                            {woofer[field].rarity})
                                        </AttributeLabel>
                                    </SelectContainer>
                                )
                            })}
                        </ControlsContainer>
                    </PlaygroundContainer>
                )}
                {activePage === 'rarity' && (
                    <RarityContainer>
                        {Object.entries(attributes).map(([attrField, attr]) => {
                            const field = attrField as WooferAttributeKey
                            return (
                                <RarityAttributeContainer key={field}>
                                    <RarityAttributeLabel>
                                        {attr.label}
                                    </RarityAttributeLabel>
                                    <RarityTraitsContainer>
                                        {attr.items.map((item) => (
                                            <RarityTraitLabelAndImage>
                                                <div>{item.text}</div>
                                                <RarityImageContainer
                                                    background={
                                                        ![
                                                            'skin',
                                                            'background',
                                                        ].includes(field)
                                                            ? baseWooferImg
                                                            : null
                                                    }
                                                >
                                                    {item.image && (
                                                        <img
                                                            key={item.key}
                                                            src={item.image}
                                                            alt={item.text}
                                                        />
                                                    )}
                                                </RarityImageContainer>
                                                <div
                                                    style={{
                                                        color: item.color,
                                                    }}
                                                >
                                                    {item.fact}
                                                </div>
                                                <div
                                                    style={{
                                                        color: item.color,
                                                    }}
                                                >
                                                    {item.rarity}
                                                </div>
                                            </RarityTraitLabelAndImage>
                                        ))}
                                    </RarityTraitsContainer>
                                </RarityAttributeContainer>
                            )
                        })}
                    </RarityContainer>
                )}
            </SubContainer>
        </MainContainer>
    )
}
